import React from 'react';
import Heading from '../../components/Heading';
import WithNavigation from '../../layouts/WithNavigation';
import ReportingForm from './ReportingForm.jsx';
import './Reporting.scss';

const Reporting = () => {
  return (
    <WithNavigation
      title="Reporting"
      top={(
        <Heading
          headline="Reporting"
        />
      )}
      bottom={
        (
          <div className='reporting'>
            <ReportingForm />
          </div>
        )
      }
    />
  );
}

export default Reporting;